/*******************************************************************************
 * Service: AccountSettings
 *
 * Gets the data from the server for the accounts, refund accounts, groups and
 * types.
 *******************************************************************************/
/* @ngInject */ export function AccountsSettingsServices($q, Accounts) {
  var mThis = this;
  var mInitialized = false;

  /*****************************************************************************
   * reloadAccounts
   *
   * Get the list of accounts.
   *****************************************************************************/
  (mThis.reloadAccounts = function () {
    return Accounts.getList().then(function (data) {
      mThis.accounts = data;
    });
  }),
    /*****************************************************************************
     * reloadGroups
     *
     * Get the list of account groups
     *****************************************************************************/
    (mThis.reloadGroups = function () {
      return Accounts.getAccountGroups().then(function (data) {
        mThis.groups = data;
      });
    });

  /*****************************************************************************
   * init
   *
   * Get data that is common to routes
   *****************************************************************************/
  mThis.init = function () {
    return mInitialized
      ? $q.resolve()
      : $q
          .all([
            mThis.reloadAccounts(),
            mThis.reloadGroups(),
            Accounts.getTypes().then(function (resp) {
              mThis.types = resp;
            })
          ])
          .then(function () {
            mInitialized = true;
          });
  };
}
